export const getCatalogTypes = state => state.admin?.catalogTypes;

export const getCatalogTypesData = state => getCatalogTypes(state)?.data;

export const getCatalogTypeById = (state, catalogTypeId) => getCatalogTypesData(state)[catalogTypeId] || null;
